import React, { useEffect } from 'react';

import Heading from '@atlaskit/heading';
import SectionMessage from '@atlaskit/section-message';
import { useSession } from 'src/services/session';

import ErrorMessage from 'src/views/components/ErrorMessage';

const InfoPanel = () => {
  const { error, loggedIn, loading, accountDomain } = useSession();
  useEffect(() => {
    let t = null;
    if (loggedIn) {
      t = setTimeout(() => {
        window.close();
      }, 1000);
    }
    return () => clearTimeout(t);
  });

  if (loading) {
    return (
      <SectionMessage>
        Processing authorization....
      </SectionMessage>
    );
  }
  if (loggedIn) {
    return (
      <SectionMessage appearance="info">
      Successfully logged in {accountDomain}! Please close this page and go back to Jira.
      </SectionMessage>
    );
  } else {
    return <ErrorMessage error={error || 'Unknown error'}/>;
  }
};

const OauthCallback = () => (
  <div style={{ maxWidth: '700px', margin: 'auto', padding: '20px' }}>
    <Heading size="medium">PagerDuty Login</Heading>
    <br/>
    <InfoPanel/>
  </div>
);

export default OauthCallback;
